const EVENT_TRANSITION_END = 'transitionend';

export function onTransitionEnd(element: EventTarget, callback: () => boolean | void): void {
    const handler = (event: Event) => {
        if (event.target !== element) {
            return;
        }

        const result = callback.apply(element, [event]);

        if (result === undefined || result === true) {
            element.removeEventListener(EVENT_TRANSITION_END, handler);
        }
    };

    element.addEventListener(EVENT_TRANSITION_END, handler);
}
